'use client';

import _slicedToArray from "/codebuild/output/src3225/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src3225/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/codebuild/output/src3225/src/s3/01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["children", "target"];
import { jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicEffect, assignRef } from '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
function createPortalNode(props) {
  var _node$classList;
  var node = document.createElement("div");
  node.setAttribute("data-portal", "true");
  typeof props.className === "string" && (_node$classList = node.classList).add.apply(_node$classList, _toConsumableArray(props.className.split(" ").filter(Boolean)));
  typeof props.style === "object" && Object.assign(node.style, props.style);
  typeof props.id === "string" && node.setAttribute("id", props.id);
  return node;
}
var defaultProps = {};
var Portal = forwardRef(function (props, ref) {
  var _useProps = useProps("Portal", defaultProps, props),
    children = _useProps.children,
    target = _useProps.target,
    others = _objectWithoutProperties(_useProps, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var nodeRef = useRef(null);
  useIsomorphicEffect(function () {
    setMounted(true);
    nodeRef.current = !target ? createPortalNode(others) : typeof target === "string" ? document.querySelector(target) : target;
    assignRef(ref, nodeRef.current);
    if (!target && nodeRef.current) {
      document.body.appendChild(nodeRef.current);
    }
    return function () {
      if (!target && nodeRef.current) {
        document.body.removeChild(nodeRef.current);
      }
    };
  }, [target]);
  if (!mounted || !nodeRef.current) {
    return null;
  }
  return createPortal( /* @__PURE__ */jsx(Fragment, {
    children: children
  }), nodeRef.current);
});
Portal.displayName = "@mantine/core/Portal";
export { Portal };